"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledgeProject.name.placeholder': 'Inserisci nome del progetto',
};
